import { get, isEmpty } from 'lodash-es';

export default ({ updateMessage, createMessage }) => {
  return {
    methods: {
      toast(success) {
        if (success) {
          return this.$appMessage(this.editing ? updateMessage : createMessage);
        }

        if (get(this.apiErrors, 'base', null)) {
          return this.apiErrors.base.forEach((error) => {
            this.$appMessage(error);
          });
        }
        if (isEmpty(this.apiErrors)) {
          return this.$appMessage('Unexpected server error. Please try again.');
        }
      },
    },
  };
};
